import { render, staticRenderFns } from "./SettingsIndexEditor.vue?vue&type=template&id=504170e7&"
import script from "./SettingsIndexEditor.vue?vue&type=script&lang=js&"
export * from "./SettingsIndexEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports